<template>
  <div class="rating-card">
    <h2 class="rating-card__name">{{ ratingCard.name }}</h2>
    <div
      v-if="ratingCard.image"
      class="rating-card__image"
      :style="{ '--image-url': `url(${imageUrl})` }"
    ></div>

    <h3 class="rating-card__score">
      {{ ratingCard.score }} <span>z-баллов</span>
    </h3>
  </div>
</template>

<script setup>
import { computed, useImageSource, toRefs } from '#imports';

const props = defineProps({
  card: {
    type: Object,
    required: true,
  },
});

const { card } = toRefs(props);

const imageUrl = computed(() => {
  if (card.value.image && card.value.image.asset) {
    return useImageSource({ image: card.value.image.asset._ref });
  }
  return '';
});

const ratingCard = computed(() => card.value);
</script>

<style lang="postcss" scoped>
.rating-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  transition: var(--default-transition) background-color;
  border: 1px solid rgba(17, 17, 17, 10%);
  border-radius: 16px;
  background-color: rgba(var(--white-color--rgb), 0.7);

  &__image {
    background: #fff;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    border-radius: var(--border-radius);
    @media (--tablet-vp) {
      display: none;
    }
  }

  &__image::before {
    content: '';
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    left: 50%;
    width: 100%;
    height: 100%;
    max-width: 320px;
    background-image: var(--image-url);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &__name {
    font-size: 32px;
    line-height: 35px;

    @media (--tablet-vp) {
      max-width: 100%;
      font-size: 24px;
      line-height: 28px;
    }
  }

  &__score {
    font-size: 32px;
    line-height: 36px;
    text-align: right;

    @media (--tablet-vp) {
      font-size: 20px;
      line-height: 24px;
    }
  }
}
</style>
